/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useRef} from 'react'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {KTSVG} from '../../../helpers'
import {AsideMenu} from './AsideMenu'

type AsideDefaultProps = {
  isOpen: boolean
  onClose: () => void
  className?: string
}

const AsideDefault: FC<AsideDefaultProps> = ({isOpen, onClose, className}) => {
  const {config} = useLayout()
  const asideRef = useRef<HTMLDivElement | null>(null)
  const {aside} = config

  const minimize = () => {
    asideRef.current?.classList.add('animating')
    setTimeout(() => {
      asideRef.current?.classList.remove('animating')
    }, 300)
  }

  return (
    <div
      id='kt_aside'
      className={clsx(
        'bg-primary shadow-md flex-col',
        {
          hidden: !isOpen,
          flex: isOpen,
          'lg:flex': true,
        },
        className
      )}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
      ref={asideRef}
    >
      {/* begin::Brand */}
      <div className='flex items-center justify-between px-4 py-6 by-primary' id='kt_aside_logo'>
        {/* begin::Logo */}
        <Link to='/'>
          <img
            alt='Logo'
            className='h-[50px]'
            src='https://res.cloudinary.com/tobilasinde/image/upload/v1753544454/schedule/asset/banner_white_guleml.png'
          />
        </Link>
        {aside.minimize && (
          <div
            id='kt_aside_toggle'
            className='text-primary ml-2 cursor-pointer'
            data-kt-toggle='true'
            data-kt-toggle-state='active'
            data-kt-toggle-target='body'
            data-kt-toggle-name='aside-minimize'
            onClick={minimize}
          >
            <KTSVG
              path={'/media/icons/duotune/arrows/arr080.svg'}
              className={'svg-icon-1 rotate-180'}
            />
          </div>
        )}
        {/* end::Aside toggler */}
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div className='flex-1 px-4'>
        <AsideMenu onLinkClick={onClose} />
      </div>
      {/* end::Aside menu */}

      {/* begin::Footer */}
      <div className='pt-5 pb-7 px-5' id='kt_aside_footer'>
        <Link
          to='/profile'
          className='w-full bg-primary text-white text-center py-2 rounded hover:bg-teal-700 transition flex items-center justify-center gap-2'
          data-bs-toggle='tooltip'
          data-bs-trigger='hover'
          data-bs-dismiss-='click'
          title='View and update your profile'
        >
          <span className='font-medium'>Profile Settings</span>
          <span className='svg-icon svg-icon-2'>
            <KTSVG path='/media/icons/duotune/general/gen005.svg' />
          </span>
        </Link>
      </div>
      {/* end::Footer */}
    </div>
  )
}

export {AsideDefault}
